module.exports = __webpack_public_path__ + "static/media/flow-image-mobile-en.54ed5025.svg";